import { User } from '../../../features/reports/users/sessionDuration';

// Ported from master commit 7f80458 ("Fixed send only company users"), which
// added company scoping for CompanyAdmin but broke SuperAdmin's unfiltered
// view: `gaUserSessions.filter(user => user.companyId === currentCompanyId)`
// compared against `undefined` when no Company is selected, so it matched
// only GA4's untagged/"(not set)" session (if any) instead of showing every
// session — collapsing the Top 5 to empty or a single broken row.
// Only scope when a companyId is actually selected; otherwise show everyone.
export const scopeGaUserSessionsByCompany = (
  sessions: User[],
  companyId: string | undefined
): User[] => {
  if (!companyId) {
    return sessions;
  }
  return sessions.filter((session) => session.companyId === companyId);
};
